/**
 * @flow
 */

import React from 'react';
import { useQuery } from '@apollo/client';
import { useSelector, useDispatch } from 'react-redux';
import { Select } from 'semantic-ui-react';
import { uniqBy, clone } from 'lodash';
import { filterByManufacturers } from '../../../actions/inventory';
import { GET_MANUFACTURERS_QUERY } from './form/ManufacturerSelect';

const mapOptions = manufacturers =>
    manufacturers.map(item => ({
        value: item.id,
        text: item.name,
    }));

function ManufacturersFilterSelect({ placeholder, multiple, value }) {
    const salon = useSelector(({ user }) => user.get('salon'));
    const dispatch = useDispatch();

    const onChange = (e, { value: val }) => {
        dispatch(filterByManufacturers(val));
    };

    const { data, loading } = useQuery(GET_MANUFACTURERS_QUERY, {
        variables: {
            salon,
            manufacturer: value || '',
            withManufacturer: !!value,
        },
    });

    let options = [];

    if (!loading && data && data.viewer) {
        let manufacturers = clone(data.viewer.salon.manufacturers.nodes);
        const manufacturer = data.manufacturer;
        manufacturer && manufacturers.push(manufacturer);
        manufacturers = uniqBy(manufacturers, 'id');
        options = mapOptions(manufacturers);
    }

    return (
        <Select
            options={options}
            onChange={onChange}
            placeholder={placeholder}
            multiple={multiple}
        />
    );
}

export default ManufacturersFilterSelect;
